import feedbackimg from "@/assets/feedback.png"
import "./index.scss"
export default function Feedback({isHide, position, tip}) { 
    function TipDesc(){
        if(tip){
            return <div className="tip mt">{tip}</div>
        }else{
            return <div>
            <div className="tip mt">扫码填写资料 等待客服联系</div>
            <div className="tip">或扫尾部客服二维码 添加客服</div>
        </div>
        }
    }
    return(
        <div className={isHide? 'feed-back-dialog':'feed-back-dialog is-show'} id="feedbackDom" style={{top: position.top, right: position.right, left: position.left}}>
            <img src={feedbackimg} className="code-img"></img>
            <TipDesc></TipDesc>
        </div>
    )
}